import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-change-language',
  templateUrl: './change-language.component.html',
  styleUrls: ['./change-language.component.css']
})
export class ChangeLanguageComponent implements OnInit {
  selected: string | null = null;
  isSave: boolean= false;

  languages= [
    // { code: 'km'},
    { code: 'en'},
    { code: 'ch'},
    { code: 'jp'},
    { code: 'kr'},
  ]

  constructor(
    public dialogRef: MatDialogRef<ChangeLanguageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
   this.selected= this.data?.lang;
  }

  ngOnInit(): void {
  }

  select(langCode: string): void {
    this.selected = langCode;
  }

  close() {
    this.dialogRef.close(this.data.lang);
  }

  onSave() {
    this.dialogRef.close(this.selected);
  }

}
